import {RANGE_CHART} from '../../common/constants';
import moment from 'moment';

export const displayTimeUnit = (tick, rangeChart) => {
  switch (rangeChart) {
  case RANGE_CHART.DAY:
    return tick;
  case RANGE_CHART.MONTH:
    return moment().month(tick - 1).format('MMMM');
  case RANGE_CHART.YEAR:
    return tick;
  default:
    return tick;
  }
};
